//# sourceMappingURL=table-body.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/table/table-body.interface.js
// module id = 1188
// module chunks = 4